import React, {Component} from 'react';
import faq9 from "../../../../../../assets/img/faq9.png";
import faq10 from "../../../../../../assets/img/faq10.png";
import {Link} from "react-router-dom";
import './AboutPayment.css';
import FocusPageId from "../../FocusPageId";
import visa_masterImage from "../../../../../../assets/img/VisaAEMaster.png";
import ContactUs from "../../ContactUs/ContactUs";

let i = 0;

class MemberRegistration extends React.Component {

    componentDidMount() {
        // window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        element.classList.add('mystyle');
        // element.style.paddingTop = "50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });


    }
    constructor(props) {
        super(props);
        this.positionAdject = this.positionAdject.bind()
    };

    positionAdject = () => {
        i++;
        // if(i<3){
        // document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop = "0px";

        // console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa    ', document.getElementById(FocusPageId.selectedId.elementId).offsetLeft);
        // }


    };

    render() {

        return (
            // onMouseMove={() => this.positionAdject()}
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <h3><b>
                        <li>支払いについて</li>
                    </b></h3>
                     <div className="brElement"></div>
















                    <h4 id="a"><b> 支払い方法を教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>
                        キットカットでは、クレジットカード支払い・PayPal 支払 いを基本とさせていただいております。
                    </p>
                    <p className='all-content-font-size'>
                        その 他、お客様ご指定の商社を経由してのお支払いをご希望されるお客様においては
                    </p>
                    {/*uncomment following segment to open contact us dialog*/}


                    {/*<p className='all-content-font-size contact-us-payment'>*/}
                        {/*<ContactUs userId={this.props.userId}/>よりご連絡ください。*/}
                    {/*</p>*/}


                    <p className='all-content-font-size'>
                        <b>お問い合わせ</b>よりご連絡ください。
                    </p>

                     <div className="brElement"></div>
                    <p className='all-content-line-height all-content-font-size'>
                        ご利用可能なクレジットカードは下記の３つです。
                    </p>
                    <div className="resp-image">
                        <img src={visa_masterImage} alt="Paypal" className="payment-img1 payment-image-mobile-visa-master"/>
                    </div>
                    <p className='all-content-font-size'>
                        <b>【ご注意】クレジットカードを選択された場合</b>
                    </p>
                    <p className='all-content-font-size'>
                        お支払いは「一括払い」のみとなります。 分割払いには対応しておりません。
                    </p>
                    <p className='all-content-font-size'>
                        クレジットカードのご利用はご本人または 会社様名義のカードに限らせていただきます
                    </p>























                     <div className="brElement"></div>
                    <h4 id="c"><b> 紙で領収書を発行してもらえますか？</b>
                    </h4>
                    <p className='all-content-font-size'>紙の領収書をご希望の場合は、アカウントページ内「請求書兼領収書」をダウンロードできるようになっております。
                    </p>
                    <p className='all-content-font-size'> 郵送による領収書の発行は行っておりません。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="d"><b> 注文後に請求書、領収書等の宛名を変更することはできますか？</b>
                    </h4>
                    <p className='all-content-line-height all-content-font-size'>変更できません。ご注文商品の各種書類についてはアカウントページのプロフィール画面にて、「お届け先住所」「請求先住所」ボタンを押すと、編集・追加することができます。
                    </p>

                    {/* <div className="brElement"></div>*/}
                    {/*<p className="spcl-txt-clr all-content-font-size"> 下記画像はサイト完成後、差し替え必要*/}
                    {/*</p>*/}

                     <div className="brElement"></div>

                    <img src={faq9} className="img-begin1"/>
                    <img src={faq10} className="img-begin1"/>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <h4 id="e"><b>2つ以上の注文について各種書類（注文明細、請求書兼領収書）をまとめることは可能ですか？</b>
                    </h4>
                    <p className='all-content-line-height all-content-font-size'>ご注文単位で発行させていただいておりますので、2つ以上の注文内容をまとめて発行、また1注文内の複数商品を分けて、書類発行することはできません。
                    </p>
                    <div className='col-md-10'></div>
                    <div className='col-md-2 col-12-custom'>
                        <Link to="/aboutpaymentTopic">
                            <span className='font-size-20'>
                            戻る
                            </span>
                        </Link>
                    </div>

                </div>
            </div>
        );
    }
}

export default MemberRegistration;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/AboutPayment.js